
export default {
  isLoggedIn: state => !!state.token,
  userData: state => state.user.data,
  userRole: state => state.role,
  userEmail: state => state.userEmail

}
